import { ApplicationError } from '@/src/shared/errors';

export class SubscribeToTopicsFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal berlangganan topik notifikasi');
  }
}
